import { Component, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: "app-testimonial",
  templateUrl: "./testimonial.component.html",
  styleUrls: ["./testimonial.component.scss"],
})
export class TestimonialComponent {
  @ViewChild('testimonialContainer') testimonialContainer!: ElementRef;

  testimonialData = [
    {
      title: "Sainik School",
      subtitle: "Surajpur Tira, Hamirpur (H.P.)",
      content: "“We have installed Virsa Interactive Flat Panels in our school with a smooth and professional setup. The built-in camera, microphone, and 1 TB SSD storage make the system highly effective for classroom teaching, interactive cultural activities, and student assessment. We are satisfied with its performance and find it extremely beneficial for modern classroom learning.”",
    },
    {
      title: "Jawahar Nehru Vidyalaya",
      subtitle: "Pandoh, District Mandi, Himachal Pradesh",
      content: "“The installation and training of the Virsa Interactive Flat Panel were carried out smoothly and professionally. Features such as the built-in camera, powerful microphone, and K–12 digital content are very helpful for students. Virsa IFP supports interactive learning and NEP-aligned teaching, and we are satisfied with its overall performance”",
    },
    {
      title: "GSSS Namhol (Principal)",
      subtitle: "Sosan, Himachal Pradesh",
      content: "“Virsa Interactive Flat Panel installation and training were smooth and satisfactory. Features including 1 TB SSD storage, in-built camera, powerful microphone, and K–12 content significantly enhance classroom learning. The solution supports NEP implementation through live interactive classes, including Yoga and AI-based learning. We are satisfied with its performance”",
    },
    {
      title: "Army Public School",
      subtitle: "Dehradun",
      content: "“The installation and training process of Virsa Interactive Flat Panel was seamless and well-organized. With features like 1 TB SSD storage, in-built camera, powerful microphone, and rich K–12 content, the panel enables interactive learning and effective NEP implementation through live classes. We are highly satisfied with the quality and performance of Virsa IFP.”",
    },
    {
      title: "अटल उत्कृष्ट राजकीय इंटर कॉलेज, ओजली (प्रधानाचार्य)",
      subtitle: "पौड़ी, उत्तराखंड",
      content: "“हमारे विद्यालय में Virsa द्वारा इंटरएक्टिव फ्लैट पैनल की स्थापना की गई है। इंस्टॉलेशन प्रक्रिया सुचारू एवं संतोषजनक रही। स्मार्ट कक्षा शिक्षण, डिजिटल कंटेंट और इंटरएक्टिव फीचर्स के माध्यम से शिक्षण अधिक प्रभावी हुआ है। हम Virsa के उत्पाद एवं सेवाओं से पूर्णतः संतुष्ट हैं।”",
    },
    {
      title: "Kendriya Vidyalaya, Jyotipuram",
      subtitle: "Reasi, Jammu",
      content: "“The Virsa Interactive Flat Panel has been seamlessly integrated into our teaching–learning process and has significantly enhanced classroom delivery. Its advanced audio-visual capabilities, user-friendly interface, and ample storage enable teachers to conduct lessons with greater confidence and efficiency. <br>Aligned with the NEP 2020 framework, the panel supports competency-based and experiential learning, making classroom sessions more interactive and engaging. Students show increased enthusiasm, active participation, and improved conceptual understanding during digital lessons. <br>Overall, the Virsa Interactive Flat Panel has proven to be a valuable educational tool, strengthening both teaching quality and student learning outcomes in our school.”",
    },
    {
      title: "PM SHRI Kendriya Vidyalaya Kathua",
      subtitle: "Jammu & Kashmir",
      content: "“The Virsa IFP Safety Shutter System provides reliable protection for interactive flat panels installed in classrooms. The robust metal construction, smooth shutter movement, and secure locking mechanism ensure safety during regular school use. The solution is durable and suitable for a school environment.”",
    },
  ];

  scrollLeft(): void {
    const container = this.testimonialContainer.nativeElement;
    const cardWidth = container.querySelector('.testimonial-card').offsetWidth;
    // content gap is 1rem = 16px usually, but let's measure if possible or just assume small gap
    // Use getComputedStyle to be precise
    const style = getComputedStyle(container);
    const gap = parseInt(style.gap || '0', 10);
    container.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
  }

  scrollRight(): void {
    const container = this.testimonialContainer.nativeElement;
    const cardWidth = container.querySelector('.testimonial-card').offsetWidth;
    const style = getComputedStyle(container);
    const gap = parseInt(style.gap || '0', 10);
    container.scrollBy({ left: (cardWidth + gap), behavior: 'smooth' });
  }
}
